/*
  eギフト選択時のチェックアウト直行。

  判定は「フォーム内に name="properties[ギフト購入]" で値が 有効 の
  有効な input があるか」だけで行う。AnyGift の内部状態は読まない。

  - PDP: ラベルの出し分け（本体 / 固定CTA / バリアントシートの3ボタン）と、
         product-form の submit を横取りしてチェックアウトへ直行する。
  - 全ページ: 退避した通常行をカートへ戻す判定だけを走らせる。

  AnyGift が差し込む要素・スクリプトには手を入れない。読むだけ。
*/
(function () {
  'use strict';

  var GIFT_PROP = 'properties[ギフト購入]';
  var GIFT_ON = '有効';
  var STASH_KEY = 'monoco_cart_stash';
  var STASH_TTL_DAYS = 14;

  /* ---------- localStorage（使えない環境では黙って無効化する） ---------- */

  function storage() {
    try {
      var k = '__eg_t';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  function readStash() {
    var ls = storage();
    if (!ls) return null;
    try {
      var raw = ls.getItem(STASH_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items) || !data.items.length) return null;
      var age = Date.now() - (data.savedAt || 0);
      if (age > STASH_TTL_DAYS * 24 * 60 * 60 * 1000) {
        ls.removeItem(STASH_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function clearStash() {
    var ls = storage();
    if (ls) {
      try {
        ls.removeItem(STASH_KEY);
      } catch (e) {}
    }
  }

  /* properties が同じ行は数量を合算する。キーは variant id + properties の正規化 */
  function lineKey(item) {
    var props = item.properties || {};
    var keys = Object.keys(props).sort();
    var parts = keys.map(function (k) {
      return k + '=' + props[k];
    });
    return String(item.id) + '|' + parts.join('&');
  }

  function saveStash(items) {
    var ls = storage();
    if (!ls || !items.length) return;
    var merged = {};
    var existing = readStash();
    if (existing) {
      existing.items.forEach(function (it) {
        merged[lineKey(it)] = { id: it.id, quantity: it.quantity, properties: it.properties || {} };
      });
    }
    items.forEach(function (it) {
      var k = lineKey(it);
      if (merged[k]) merged[k].quantity += it.quantity;
      else merged[k] = { id: it.id, quantity: it.quantity, properties: it.properties || {} };
    });
    var list = Object.keys(merged).map(function (k) {
      return merged[k];
    });
    try {
      ls.setItem(STASH_KEY, JSON.stringify({ savedAt: Date.now(), items: list }));
    } catch (e) {}
  }

  /* ---------- 判定 ---------- */

  function isEgiftSelected(form) {
    if (!form) return false;
    var inputs = form.querySelectorAll('[name="' + GIFT_PROP + '"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].disabled && inputs[i].value === GIFT_ON) return true;
    }
    return false;
  }

  function isGiftLine(item) {
    var props = item && item.properties;
    return !!(props && props['ギフト購入'] === GIFT_ON);
  }

  /* ---------- 文言 ---------- */

  function t(key, fallback) {
    var s = window.egiftDirectStrings;
    return (s && s[key]) || fallback;
  }

  /* ---------- ラベルの出し分け ---------- */

  /* 同じフォームを submit するボタンをすべて集める（本体 / 固定CTA / バリアントシート） */
  function submitButtonsFor(form) {
    var list = [];
    var inside = form.querySelectorAll('button[type="submit"][name="add"]');
    Array.prototype.push.apply(list, inside);
    /* form.id は <input name="id"> に遮られる（form.elements がプロパティとして生える）。
       必ず getAttribute で取る */
    var formId = form.getAttribute('id');
    if (formId) {
      var outside = document.querySelectorAll('button[type="submit"][form="' + formId + '"]');
      Array.prototype.push.apply(list, outside);
    }
    return list.filter(function (b, i, a) {
      return a.indexOf(b) === i;
    });
  }

  function labelNode(btn) {
    return btn.querySelector('span:not(.loading__spinner):not(.svg-wrapper)') || btn;
  }

  function applyLabels(form) {
    var on = isEgiftSelected(form);
    submitButtonsFor(form).forEach(function (btn) {
      /* 売り切れ・選択不可などの状態は触らない */
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      /* 取り置きラベルを出している外側ボタンは applyStashLabels に任せる */
      if (btn.dataset.egiftStash === 'on') return;
      var node = labelNode(btn);
      if (on) {
        if (!btn.dataset.egiftOrigLabel) btn.dataset.egiftOrigLabel = node.textContent;
        node.textContent = t('checkout', '購入手続きに進む');
        btn.dataset.egiftDirect = 'on';
      } else if (btn.dataset.egiftOrigLabel) {
        node.textContent = btn.dataset.egiftOrigLabel;
        delete btn.dataset.egiftOrigLabel;
        delete btn.dataset.egiftDirect;
      }
    });
    /* eギフト選択中は動的チェックアウトを隠す（プロパティが載らない経路を塞ぐ）。
       Shop Pay の SDK がインラインで display:block !important を当てるので、
       こちらもインラインの !important で上書きする */
    document.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      el.hidden = on;
      if (on) el.style.setProperty('display', 'none', 'important');
      else el.style.removeProperty('display');
    });
    syncNotice(form);
    /* eギフト選択を解除した直後は、退避した通常行を戻す */
    if (!on) maybeRestore();
  }

  /* ---------- チェックアウト直行 ---------- */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function addLinesBackSequentially(items) {
    return items.reduce(function (chain, it) {
      return chain.then(function (acc) {
        return postJSON(window.Shopify.routes.root + 'cart/add.js', {
          items: [{ id: it.id, quantity: it.quantity, properties: it.properties || {} }],
        })
          .then(function (res) {
            acc.push(!(res && res.status));
            return acc;
          })
          .catch(function () {
            acc.push(false);
            return acc;
          });
      });
    }, Promise.resolve([]));
  }

  function directCheckout(productForm, form, evt) {
    var root = window.Shopify.routes.root;
    var stashed = [];

    productForm.setLoading(true);

    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        /* eギフト行は破棄、通常行は退避 */
        stashed = (cart.items || []).filter(function (it) {
          return !isGiftLine(it);
        }).map(function (it) {
          return { id: it.id, quantity: it.quantity, properties: it.properties || {} };
        });
        if (stashed.length) saveStash(stashed);
        return postJSON(root + 'cart/clear.js', {});
      })
      .then(function () {
        /* 既存のフォーム内容（AnyGift のプロパティを含む）をそのまま送る */
        var config = window.fetchConfig ? window.fetchConfig('javascript') : { method: 'POST', headers: {} };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(form);
        return fetch(root + 'cart/add', config).then(function (r) {
          return r.json();
        });
      })
      .then(function (res) {
        if (res && res.status) {
          return rollback(productForm, stashed, res.description || res.message);
        }
        window.location.href = root + 'checkout';
      })
      .catch(function (e) {
        console.error('[egift-direct-checkout]', e);
        return rollback(productForm, stashed, t('error', '処理に失敗しました。もう一度お試しください。'));
      });
  }

  /* 追加に失敗したときの戻し。
     案内ボタン（2段階）からの経路では、退避はこの関数の外（stashThenSubmit）で
     済んでいて directCheckout 側の stashed は空になる。保存済みの退避データを
     必ず見てから戻す。 */
  function rollback(productForm, fallbackLines, message) {
    var data = readStash();
    var lines = data && data.items && data.items.length ? data.items : fallbackLines || [];
    clearStash();
    return addLinesBackSequentially(lines).then(function () {
      productForm.showError(message);
      productForm.setLoading(false);
    });
  }

  /* ---------- 通常行がある場合の案内 ----------

     AnyGift は「カートに他の商品がある状態」でのeギフト追加を、
     購入ボタンの click を capture 段階で握りつぶして止める（本番でも同じ挙動）。
     テーマ側の submit ハンドラまで届かないため、先に取り置き（退避＋カートを空に）
     してからプログラムで送信ボタンを押し直す導線を、ボタンの下に出す。 */

  var noticeState = { hasNormalLines: false, checking: false };

  function noticeHost(form) {
    return form.querySelector('.product-form__buttons') || form;
  }

  function removeNotice(form) {
    var el = form.querySelector('.egift-stash-notice');
    if (el) el.remove();
    hideMainSubmit(form, false);
  }

  /* 本体の送信ボタン。見た目上だけ隠し、支援技術・キーボードからも外す。
     取り置き後にプログラムから click するので DOM からは消さない */
  function mainSubmit(form) {
    return form.querySelector('button[type="submit"][name="add"]');
  }

  function hideMainSubmit(form, hide) {
    var btn = mainSubmit(form);
    if (!btn) return;
    btn.classList.toggle('egift-visually-hidden', hide);
    if (hide) {
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
    } else {
      btn.removeAttribute('aria-hidden');
      btn.removeAttribute('tabindex');
    }
  }

  /* 固定CTA・バリアントシートのボタン（form 属性でフォームに紐づく外側のボタン） */
  function outsideSubmitButtons(form) {
    var formId = form.getAttribute('id');
    if (!formId) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('button[type="submit"][form="' + formId + '"]')
    );
  }

  /* 通常行があるあいだ、外側のボタンは「取り置いて購入手続きに進む」にして
     取り置き処理に入れる。押しても AnyGift に止められる経路を残さない */
  function applyStashLabels(form) {
    var on = isEgiftSelected(form) && noticeState.hasNormalLines;
    outsideSubmitButtons(form).forEach(function (btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var node = labelNode(btn);
      if (on) {
        if (!btn.dataset.egiftStashBound) {
          btn.dataset.egiftStashBound = '1';
          btn.addEventListener(
            'click',
            function (evt) {
              if (btn.dataset.egiftStash !== 'on') return;
              evt.preventDefault();
              evt.stopImmediatePropagation();
              stashThenSubmit(form, btn);
            },
            true
          );
        }
        node.textContent = t('stashAction', '取り置いて購入手続きに進む');
        btn.dataset.egiftStash = 'on';
      } else if (btn.dataset.egiftStash === 'on') {
        delete btn.dataset.egiftStash;
        /* ラベルは applyLabels が状態に応じて付け直す */
        node.textContent = btn.dataset.egiftOrigLabel || node.textContent;
        applyLabels(form);
      }
    });
  }

  function renderNotice(form) {
    if (form.querySelector('.egift-stash-notice')) return;
    var box = document.createElement('div');
    box.className = 'egift-stash-notice';
    var p = document.createElement('p');
    p.className = 'egift-stash-notice__text';
    p.textContent = t('stashNotice', 'eギフトは単独でのご購入になります。カートの商品はいったん取り置き、ご購入後にカートへ戻します。');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--full-width button--primary egift-stash-notice__button';
    btn.textContent = t('stashAction', '取り置いて購入手続きに進む');
    btn.addEventListener('click', function () {
      stashThenSubmit(form, btn);
    });
    /* 案内文はボタンの上の補足テキスト */
    box.appendChild(p);
    box.appendChild(btn);
    /* 本体ボタンがあった位置にそのまま置く */
    var main = mainSubmit(form);
    if (main && main.parentNode) main.parentNode.insertBefore(box, main);
    else noticeHost(form).appendChild(box);
  }

  /* 必須項目は「プロパティの値が空でないか」だけで見る。AnyGift の内部状態は読まない */
  function requiredPropsFilled(form) {
    var names = ['properties[ギフト購入メッセージ]', 'properties[ギフト贈り主]'];
    return names.every(function (n) {
      var el = form.querySelector('[name="' + n + '"]');
      return el && String(el.value || '').trim() !== '';
    });
  }

  function syncNotice(form) {
    if (!isEgiftSelected(form)) {
      removeNotice(form);
      noticeState.hasNormalLines = false;
      return;
    }
    if (noticeState.checking) return;
    noticeState.checking = true;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        noticeState.hasNormalLines = (cart.items || []).some(function (it) {
          return !isGiftLine(it);
        });
        if (noticeState.hasNormalLines && isEgiftSelected(form)) {
          renderNotice(form);
          hideMainSubmit(form, true);
        } else {
          removeNotice(form);
        }
        applyStashLabels(form);
      })
      .catch(function () {})
      .finally(function () {
        noticeState.checking = false;
      });
  }

  function stashThenSubmit(form, btn) {
    /* 必須項目が空のままならカートに触らず、AnyGift のエラーを出させる */
    if (!requiredPropsFilled(form)) {
      hideMainSubmit(form, false);
      var submit = mainSubmit(form);
      if (submit) submit.click();
      hideMainSubmit(form, true);
      return;
    }
    var root = window.Shopify.routes.root;
    btn.disabled = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var normals = (cart.items || []).filter(function (it) {
          return !isGiftLine(it);
        }).map(function (it) {
          return { id: it.id, quantity: it.quantity, properties: it.properties || {} };
        });
        if (normals.length) saveStash(normals);
        return postJSON(root + 'cart/clear.js', {});
      })
      .then(function () {
        removeNotice(form);
        noticeState.hasNormalLines = false;
        hideMainSubmit(form, false);
        /* カートが空になったので AnyGift はクリックを通す。
           ここで通れば1段階、通らなければ案内を消したうえで
           利用者に通常の「購入手続きに進む」を押してもらう2段階になる */
        var submit = submitButtonsFor(form)[0];
        if (submit) submit.click();
      })
      .catch(function (e) {
        console.error('[egift-direct-checkout]', e);
        btn.disabled = false;
      });
  }

  /* ---------- PDP ---------- */

  function setupPdp() {
    var productForm = document.querySelector('product-form');
    if (!productForm) return;
    var form = productForm.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    /* product-form.js のローディング・エラー表示を借りる */
    var helper = {
      setLoading: function (on) {
        submitButtonsFor(form).forEach(function (btn) {
          btn.classList.toggle('loading', on);
          if (on) btn.setAttribute('aria-disabled', 'true');
          else btn.removeAttribute('aria-disabled');
          var sp = btn.querySelector('.loading__spinner');
          if (sp) sp.classList.toggle('hidden', !on);
        });
      },
      showError: function (message) {
        if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage(message);
      },
    };

    /* 送信の横取り。capture で product-form.js より先に受ける */
    form.addEventListener(
      'submit',
      function (evt) {
        if (!isEgiftSelected(form)) return; /* 通常購入は一切触らない */
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (form.dataset.egiftBusy === '1') return; /* 二重送信を防ぐ */
        form.dataset.egiftBusy = '1';
        directCheckout(helper, form, evt).then(function () {
          form.dataset.egiftBusy = '';
        });
      },
      true
    );

    applyLabels(form);

    /* AnyGift の DOM 変更と、バリアント変更によるセクション再描画の両方を拾う。
       再描画されない安定した親に当てる */
    var host = document.querySelector('product-info') || document.getElementById('MainContent') || document.body;
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      /* rAF はタブが非アクティブだと止まるので setTimeout を使う */
      pending = window.setTimeout(function () {
        pending = null;
        var current = document.querySelector('product-form');
        var currentForm = current && current.querySelector('form[data-type="add-to-cart-form"]');
        if (currentForm && currentForm !== form) {
          /* セクションが差し替わったら張り直す */
          observer.disconnect();
          setupPdp();
          return;
        }
        applyLabels(form);
      }, 0);
    });
    observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
  }

  /* ---------- 退避した通常行の復元（全ページ） ---------- */

  var restoring = false;

  function notify(message) {
    var el = document.createElement('div');
    el.className = 'egift-restore-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    window.setTimeout(function () {
      el.classList.add('is-leaving');
      window.setTimeout(function () {
        el.remove();
      }, 400);
    }, 4000);
  }

  function refreshCartCount() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    return fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('shopify-section-cart-icon-bubble');
        var host = document.getElementById('shopify-section-cart-icon-bubble');
        if (next && host) host.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  function maybeRestore() {
    if (restoring) return;
    /* eギフト選択中のPDPでは戻さない（取り置いた直後に戻ってしまうため） */
    var pdpForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (pdpForm && isEgiftSelected(pdpForm)) return;
    var stash = readStash();
    if (!stash) return;
    restoring = true;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        /* カートにeギフト行が1つでもあるうちは戻さない */
        var hasGift = (cart.items || []).some(isGiftLine);
        if (hasGift) {
          restoring = false;
          return null;
        }
        return addLinesBackSequentially(stash.items).then(function (results) {
          clearStash();
          var ok = results.filter(Boolean).length;
          if (!ok) {
            restoring = false;
            return null;
          }
          return refreshCartCount().then(function () {
            notify(
              ok === results.length
                ? t('restored', 'カートの商品を元に戻しました')
                : t('restoredPartial', '一部の商品は在庫切れのため戻せませんでした')
            );
            restoring = false;
          });
        });
      })
      .catch(function () {
        restoring = false;
      });
  }

  function init() {
    setupPdp();
    maybeRestore();
    /* カートページでの行削除など、遷移を伴わない更新のあとにも見る。
       Dawn の PUB_SUB_EVENTS / subscribe は classic script のトップレベル const なので
       window のプロパティにはならない。素の識別子で参照する */
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          maybeRestore();
        });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
